import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DesktopAppIconModal from '../components/DesktopAppIconModal';
import LivingRoomConsole, { BRIEFING_ROOM_WELCOME } from '../components/LivingRoomConsole';
import LivingRoomQrModal from '../components/LivingRoomQrModal';
import {
  DESKTOP_ICON_MENU_LABEL,
  PHONE_QR_MENU_LABEL,
} from '../lib/desktopAppIcon';
import { SCREENS } from '../lib/screenRegistry';

const PRIVATE_WELCOME = BRIEFING_ROOM_WELCOME;

const SUBSCRIPTION_ID = 'ELT-ORG-DEV-9842';
const SUBSCRIPTION_DAYS_LEFT = 28;

export default function PrivateMenteeLounge() {
  const navigate = useNavigate();
  const [qrOpen, setQrOpen] = useState(false);
  const [desktopIconOpen, setDesktopIconOpen] = useState(false);

  return (
    <LivingRoomConsole
      screenId={SCREENS.PRO08}
      welcomeScript={PRIVATE_WELCOME}
      menuContent={(closeMenu) => (
        <>
          <p className="living-room-util-item living-room-util-static">
            Subscription: {SUBSCRIPTION_ID}
          </p>
          <p className="living-room-util-item living-room-util-static">
            Subscription days left: {SUBSCRIPTION_DAYS_LEFT}
          </p>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              navigate('/pro-setup');
            }}
          >
            Review Setup
          </button>
          <button type="button" className="living-room-util-item" onClick={closeMenu}>
            Socratic Reflection History
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              setDesktopIconOpen(true);
            }}
          >
            {DESKTOP_ICON_MENU_LABEL}
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              setQrOpen(true);
            }}
          >
            {PHONE_QR_MENU_LABEL}
          </button>
          <button type="button" className="living-room-util-item" onClick={closeMenu}>
            Renew subscription
          </button>
          <a
            className="living-room-util-item"
            href="mailto:support@mentology.com.au"
            onClick={closeMenu}
          >
            Contact technical support
          </a>
        </>
      )}
      qrModal={
        <>
          {qrOpen ? (
            <LivingRoomQrModal
              titleId="private-lounge-qr-title"
              onClose={() => setQrOpen(false)}
            />
          ) : null}
          {desktopIconOpen ? (
            <DesktopAppIconModal
              titleId="private-lounge-desktop-icon-title"
              onClose={() => setDesktopIconOpen(false)}
            />
          ) : null}
        </>
      }
    />
  );
}
